import BaseComponent from '../../../js/base-component'
import { Splide } from '@splidejs/splide/build/complete/complete';

class CompanySlider extends BaseComponent {
  constructor(options) {
    super(options);
  }
  onInit() {
    this.splide = new Splide(this.element.querySelector('.u-company-slider__slider'), {
        type: 'loop',
        pagination: false,
        arrows: true,
        perPage: 2,
        perMove: 1,
        gap: "1rem",
        padding: {
          left : '11%',
          right: '11%',
        },
        breakpoints: {
          767: {
              arrows: false,
              pagination: true,
              perPage: 1,
              perMove: 1,
              padding: 0,
          },
          1023: {
              arrows: false,
              pagination: true,
              perPage: 2,
              perMove: 1,
              gap: "1rem",
              padding: 0,
          },
        },
    } );

    this.splide.on('arrows:mounted', () => {
      const arrows = this.element.querySelector('.splide__arrows'),
            teaserImage = this.element.querySelector('.u-teaser-event__image img'),
            ar = 0.75,
            marginTop = 20,
            iconHeightHalf = 18;

      if (arrows && teaserImage) {
        // set Arrows position
        arrows.style.top = (((teaserImage.width * ar + marginTop) / 2) - iconHeightHalf ) + "px";
      }
    });

    // this.splide.on('active', function (e) {
    //   e.slide.parentElement.style.height = 'initial';
    //   e.slide.parentElement.style.height = e.slide.querySelector('.u-link-slider__item').offsetHeight + 'px';
    // });

    this.splide.mount();
  }
}

export default {
  name: 'CompanySlider',
  definition: CompanySlider
};